import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@origo/origo-ui';

interface UnsavedChangesDialogProps {
    open: boolean;
    /** Bli i skjemaet og behold endringene. */
    onStay: () => void;
    /** Forkast endringene og fullfør navigasjonen. */
    onDiscard: () => void;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({ open, onStay, onDiscard }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onStay}
            title={t('unsavedChanges.title')}
            footer={
                <>
                    <Button variant="secondary" onClick={onStay}>
                        {t('unsavedChanges.stay')}
                    </Button>
                    <Button variant="danger" onClick={onDiscard}>
                        {t('unsavedChanges.discard')}
                    </Button>
                </>
            }
        >
            <p>{t('unsavedChanges.message')}</p>
        </Dialog>
    );
};

export default UnsavedChangesDialog;
